
$(document).on('submit', 'form.confirm', function(e){

	e.preventDefault();

	var $form = $(this);	
	var $msg =  $(this).attr('data-msg');

	if($msg === undefined)
		$msg = "Confirme la acción";


	$form.find('button').attr('disabled', 'disabled');

	swal({
	  title: $msg,
	  icon: "warning",
	  buttons: ["Cancelar", "Confirmar"],
	  dangerMode: true
	})

	.then(function(result) {
	  
	  if (result) {
	  	
	  	show_loading();
	  	$(document).off('submit', 'form.confirm');
	  	$form.unbind('submit').submit();	  	


	  } else {
	  	
	  	hide_loading();
	  	$form.find('button').removeAttr('disabled');	  	

	    return false;
	    
	  }
	});

});